import { combineReducers } from 'redux-immutable';

import usersPageReducer from './usersPageReducer';
import credentialListReducer from './credentialListReducer';
import groupTableReducer from './groupTableReducer';
import freelancerTableReducer from './freelancerTableReducer';
import userWizardReducer from './userWizardReducer';
import serviceTableReducer from './serviceTableReducer';
import projectListReducer from './projectListReducer';
import projectViewReducer from './projectViewReducer';
import clientTableReducer from './clientTableReducer';
import taskListReducer from './taskListReducer';
import formReducer from './formReducer';
import topBarReducer from './topBarReducer';
import articleListReducer from './articleListReducer';
import eventTableReducer from './eventTableReducer';
import paymentTableReducer from './paymentTableReducer';
import legalEntityTableReducer from './legalEntityTableReducer';
import timerReducer from './timerReducer';
import notificationDrawerReducer from './notificationDrawerReducer';
import reportReducer from './reportReducer';
import companySignUpReducer from './companySignUpReducer';
import tasksBoardReducer from './tasksBoardReducer';
import taskTemplateTableReducer from './taskTemplateTableReducer';
import analyticsReducer from './analyticsReducer';
import invoiceTableReducer from './invoiceTableReducer';
import taskScheduleTableReducer from './taskScheduleTableReducer';
import eventScheduleTableReducer from './eventScheduleTableReducer';
import taskTreeReducer from './taskTreeReducer';
import searchReducer from './searchReducer';
import appReducer from './appReducer';

const uiReducer = combineReducers({
  notificationDrawer: notificationDrawerReducer,
  topBar: topBarReducer,
  timer: timerReducer,
  usersPage: usersPageReducer,
  credentialList: credentialListReducer,
  groupTable: groupTableReducer,
  freelancerTable: freelancerTableReducer,
  userWizard: userWizardReducer,
  serviceTable: serviceTableReducer,
  projectList: projectListReducer,
  projectView: projectViewReducer,
  clientTable: clientTableReducer,
  taskList: taskListReducer,
  tasksBoard: tasksBoardReducer,
  articleList: articleListReducer,
  eventTable: eventTableReducer,
  paymentTable: paymentTableReducer,
  invoiceTable: invoiceTableReducer,
  legalEntityTable: legalEntityTableReducer,
  report: reportReducer,
  forms: formReducer,
  companySignUp: companySignUpReducer,
  taskScheduleTable: taskScheduleTableReducer,
  taskTemplateTable: taskTemplateTableReducer,
  eventScheduleTable: eventScheduleTableReducer,
  analytics: analyticsReducer,
  taskTree: taskTreeReducer,
  searchPage: searchReducer,
  app: appReducer,
});

export default uiReducer;
